import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, IPassengerAddressDto } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetPassengersAddressesCommand extends IRequestCommand<
  IGetPassengerAddressResponse[],
  ErrorDetails,
  IGetPassengerAddressCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'passengers/{passengerId}/addresses';
  public override setParameters(parameters: IGetPassengerAddressCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{passengerId}',
      parameters.passengerId.toString()
    );
  }
}

export interface IGetPassengerAddressCommandParameters
  extends ICommandParameters {
  passengerId: number;
}

export interface IGetPassengerAddressResponse
  extends IPassengerAddressDto,
    ICommandResponse {}
